import { jsx as d } from "react/jsx-runtime";
import { createPolymorphicComponent as T, Text as i } from "@mantine/core";
import m from "clsx";
import { forwardRef as h } from "react";
import './TextComponent.css';const k = "_colorTextTitle_176kk_9", y = "_colorTextBase_176kk_13", p = "_colorTextMuted_176kk_17", w = "_colorTextFaint_176kk_21", v = "_colorTextRed_176kk_25", g = "_colorTextYellow_176kk_29", b = "_colorTextGreen_176kk_33", u = "_colorTextOrange_176kk_37", L = "_colorTextPrimary_176kk_41", M = "_colorTextWhite_176kk_45", r = {
  colorTextTitle: k,
  colorTextBase: y,
  colorTextMuted: p,
  colorTextFaint: w,
  colorTextRed: v,
  colorTextYellow: g,
  colorTextGreen: b,
  colorTextOrange: u,
  colorTextPrimary: L,
  colorTextWhite: M,
  "hover-colorTextTitle": "_hover-colorTextTitle_176kk_49",
  "hover-colorTextBase": "_hover-colorTextBase_176kk_53",
  "hover-colorTextMuted": "_hover-colorTextMuted_176kk_57",
  "hover-colorTextFaint": "_hover-colorTextFaint_176kk_61",
  "hover-colorTextRed": "_hover-colorTextRed_176kk_65",
  "hover-colorTextYellow": "_hover-colorTextYellow_176kk_69",
  "hover-colorTextGreen": "_hover-colorTextGreen_176kk_73",
  "hover-colorTextOrange": "_hover-colorTextOrange_176kk_77",
  "hover-colorTextPrimary": "_hover-colorTextPrimary_176kk_81",
  "hover-colorTextWhite": "_hover-colorTextWhite_176kk_85"
}, S = "_text_1w8tr_2", C = "_componentSmall_1w8tr_2", f = "_componentTextEntry_1w8tr_2", P = "_componentMedium_1w8tr_2", R = "_display_1w8tr_2", X = "_displayXLarge_1w8tr_2", B = "_headerAllCaps_1w8tr_2", F = "_header_1w8tr_2", G = "_headerSmall_1w8tr_2", O = "_headerMedium_1w8tr_2", W = "_headerLarge_1w8tr_2", Y = "_headerXLarge_1w8tr_2", $ = "_body_1w8tr_2", A = "_bodyLegal_1w8tr_2", E = "_bodySmall_1w8tr_2", U = "_bodyMedium_1w8tr_2", j = "_bodyLarge_1w8tr_2", N = "_inline_1w8tr_92", o = {
  text: S,
  componentSmall: C,
  componentTextEntry: f,
  componentMedium: P,
  display: R,
  displayXLarge: X,
  headerAllCaps: B,
  header: F,
  headerSmall: G,
  headerMedium: O,
  headerLarge: W,
  headerXLarge: Y,
  body: $,
  bodyLegal: A,
  bodySmall: E,
  bodyMedium: U,
  bodyLarge: j,
  inline: N
}, I = T(
  h(
    ({ variant: _ = "bodyMedium", color: t = "base", hoverColor: e, className: l, inline: c, ...n }, a) => {
      const s = `colorText${t[0].toUpperCase()}${t.slice(1)}`, x = e ? r[`hover-colorText${e[0].toUpperCase()}${e.slice(1)}`] : void 0;
      return /* @__PURE__ */ d(
        i,
        {
          ref: a,
          component: "span",
          className: m(l, o.text, o[_], c && o.inline, r[s], x),
          ...n
        }
      );
    }
  )
);
export {
  I as TextComponent
};
